import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import ModalLoad from '../../../components/modal/ModalLoad';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';

function SubAdminEnvironment(props) {
    const formenvRef = useRef(null)

    const modbus_id_irr1Ref = useRef(null)
    const modbus_id_irr2Ref = useRef(null)
    const modbus_id_amb_rhRef = useRef(null)
    const modbus_id_temp_panelRef = useRef(null)
    const modbus_id_temp_racewayRef = useRef(null)
    const modbus_id_temp_winspeedRef = useRef(null)
    const modbus_idRef = useRef(null)
    const modbus_id_waterlevelRef = useRef(null)
    const irr2_nameRef = useRef(null)

    const [environmentitem, setEnvironmentitem] = useState({
        ipaddress: '',
        modbus_id: 0,
        has_irr2: false,
        irr1_name: '',
        irr2_name: '',
        irr_max_range: 0,
        has_windspeed: false,
        has_waterlevel: false,
        modbus_id_waterlevel: 0,
        sequence_type: 0,
        modbus_id_irr1: 0,
        modbus_id_irr2: 0,
        modbus_id_amb_rh: 0,
        modbus_id_temp_panel: 0,
        modbus_id_temp_raceway: 0,
        modbus_id_temp_winspeed: 0,
        edittime: ''
    });
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(message) {

    }

    useEffect(() => {
        if (Number(environmentitem.sequence_type) !== 0) {
            modbus_id_irr1Ref.current.disabled = false
            modbus_id_irr2Ref.current.disabled = false
            modbus_id_amb_rhRef.current.disabled = false
            modbus_id_temp_panelRef.current.disabled = false
            modbus_id_temp_racewayRef.current.disabled = false
            modbus_id_temp_winspeedRef.current.disabled = false
            modbus_idRef.current.disabled = true
        } else {
            modbus_id_irr1Ref.current.disabled = true
            modbus_id_irr2Ref.current.disabled = true
            modbus_id_amb_rhRef.current.disabled = true
            modbus_id_temp_panelRef.current.disabled = true
            modbus_id_temp_racewayRef.current.disabled = true
            modbus_id_temp_winspeedRef.current.disabled = true
            modbus_idRef.current.disabled = false
        }
    }, [environmentitem.sequence_type]);

    useEffect(() => {
        if (environmentitem.has_waterlevel) {
            modbus_id_waterlevelRef.current.disabled = false
        } else {
            modbus_id_waterlevelRef.current.disabled = true
            setEnvironmentitem({
                ...environmentitem,
                modbus_id_waterlevel: 0
            })
        }
    }, [environmentitem.has_waterlevel]);

    useEffect(() => {
        if (environmentitem.has_irr2) {
            irr2_nameRef.current.disabled = false
        } else {
            irr2_nameRef.current.disabled = true
            irr2_nameRef.current.value = ""
            setEnvironmentitem({
                ...environmentitem,
                waterlevel_chanel: ''
            })
        }
    }, [environmentitem.has_irr2]);

    useEffect(() => {
        api_get_list()
        return () => {
            setEnvironmentitem({});
        }
    }, []);

    async function api_get_list() {
        setmodal_load({ enable: true, message: "Loading environment." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/environment/getdata", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setEnvironmentitem(response.data.environment)
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    async function api_save_data() {
        var formelement = formenvRef.current
        if (formelement.checkValidity() === false) {
            formelement.classList.add("was-validated");
        }
        else {
            setmodal_load({ enable: true, message: "Saving environment." })
            await sleep(500)

            formelement.classList.remove("was-validated");
            const formData = new FormData();
            formData.append('ipaddress', environmentitem.ipaddress)
            formData.append('modbus_id', environmentitem.modbus_id)
            formData.append('has_irr2', environmentitem.has_irr2)
            formData.append('irr1_name', environmentitem.irr1_name)
            formData.append('irr2_name', environmentitem.irr2_name)
            formData.append('irr_max_range', environmentitem.irr_max_range)
            formData.append('has_windspeed', environmentitem.has_windspeed)
            formData.append('has_waterlevel', environmentitem.has_waterlevel)
            formData.append('modbus_id_waterlevel', environmentitem.modbus_id_waterlevel)
            formData.append('sequence_type', environmentitem.sequence_type)
            formData.append('modbus_id_irr1', environmentitem.modbus_id_irr1)
            formData.append('modbus_id_irr2', environmentitem.modbus_id_irr2)
            formData.append('modbus_id_amb_rh', environmentitem.modbus_id_amb_rh)
            formData.append('modbus_id_temp_panel', environmentitem.modbus_id_temp_panel)
            formData.append('modbus_id_temp_raceway', environmentitem.modbus_id_temp_raceway)
            formData.append('modbus_id_temp_winspeed', environmentitem.modbus_id_temp_winspeed)

            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/environment/edit", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    setmodal_load({ enable: false, message: "" })
                    if (response.data.status === 'OK') {
                        setModal_popup({
                            modaltype: 'modal-success',
                            headers: 'Success',
                            message: "Your environment has been saved to database.",
                            enable: true
                        });
                    }
                    else {
                        setModal_popup({
                            modaltype: 'modal-error',
                            headers: 'Error',
                            message: response.data.message,
                            enable: true
                        })
                    }
                    if (response.data.environment !== undefined) {
                        setEnvironmentitem(response.data.environment)
                    }
                })
                .catch((err) => {
                    setmodal_load({ enable: false, message: "" })
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: err.message,
                        enable: true
                    })
                });
        }
    }

    async function api_reboot() {
        setmodal_load({ enable: true, message: "Rebooting application....." })
        await sleep(500)

        const formData = new FormData()
        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/setting/app/reboot", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your application has been recieved reboot command.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="fas fa-cloud-sun"></i> Environment</h4>
                                    <p className="mb-3">Manage all  environment</p>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mt-0 mb-2" />
                            <div className="d-flex justify-content-start gap-3 mt-2">
                                <button className="btn btn-success btn-sm" type="button" onClick={() => { api_get_list() }}><i className="fas fa-sync-alt"></i> Refresh</button>
                                <button className="btn btn-danger btn-sm" type="button" onClick={() => { api_reboot() }}><i className="fas fa-power-off"></i> Reboot Service</button>
                            </div>
                        </div>
                    </div>

                    <form ref={formenvRef} className='mt-3 mb-1 mb-md-4' action="" method="POST" encType="multipart/form-data" >
                        <div className="row">
                            <h6>Environment Connection</h6>
                            <div className="col-md-2">
                                <div className="form-group mb-3">
                                    <label htmlFor="ipaddress">IP Address (IPV4)</label>
                                    <input type="text" className="form-control" name="ipaddress" pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$" value={environmentitem.ipaddress} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            ipaddress: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                            <div className="col-md-1">
                                <div className="form-group mb-3">
                                    <label htmlFor="modbus_id">Modbus ID</label>
                                    <input type="number" className="form-control" ref={modbus_idRef} name="modbus_id" min={1} max={256} value={environmentitem.modbus_id} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            modbus_id: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="irr1_name">Irradiation No.1 Display Name</label>
                                    <input type="text" className="form-control" name="irr1_name" value={environmentitem.irr1_name} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            irr1_name: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-check mb-3">
                                    <input name="has_irr2" className="form-check-input" type="checkbox" checked={environmentitem.has_irr2} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            has_irr2: e.target.checked
                                        })
                                    }} />
                                    <label htmlFor="has_irr2" className="form-check-label">
                                        Enable Irradiation No.2
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="irr2_name">Irradiation No.2 Display Name</label>
                                    <input type="text" className="form-control" name="irr2_name" ref={irr2_nameRef} value={environmentitem.irr2_name} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            irr2_name: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="irr_max_range">Irradiation Max Range</label>
                                    <input type="number" className="form-control" name="irr_max_range" min={1} max={2000} value={environmentitem.irr_max_range} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            irr_max_range: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-check mb-3">
                                    <input name="has_windspeed" className="form-check-input" type="checkbox" checked={environmentitem.has_windspeed} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            has_windspeed: e.target.checked
                                        })
                                    }} />
                                    <label htmlFor="has_windspeed" className="form-check-label">
                                        Enable Wind WindSpeed/Direction
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-check mb-3">
                                    <input name="has_waterlevel" className="form-check-input" type="checkbox" checked={environmentitem.has_waterlevel} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            has_waterlevel: e.target.checked
                                        })
                                    }} />
                                    <label htmlFor="has_waterlevel" className="form-check-label">
                                        Enable Water Level
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="modbus_id_waterlevel">Modbus ID Water Level</label>
                                    <input type="number" className="form-control" ref={modbus_id_waterlevelRef} name="modbus_id_waterlevel" min={1} max={256} value={environmentitem.modbus_id_waterlevel} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            modbus_id_waterlevel: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-md-3">
                                <label htmlFor="sequence_type">Communication Mode</label>
                                <select name="sequence_type" className="form-select mb-3" value={environmentitem.sequence_type} onChange={(e) => {
                                    setEnvironmentitem({
                                        ...environmentitem,
                                        sequence_type: e.target.value
                                    })
                                }} required>
                                    <option value={0}>Single Package</option>
                                    <option value={1}>Split Package by Device</option>
                                </select>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="modbus_id_irr1">Modbus ID Irradiation 1</label>
                                    <input type="number" className="form-control" ref={modbus_id_irr1Ref} name="modbus_id_irr1" min={1} max={256} value={environmentitem.modbus_id_irr1} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            modbus_id_irr1: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="modbus_id_irr2">Modbus ID Irradiation 2</label>
                                    <input type="number" className="form-control" ref={modbus_id_irr2Ref} name="modbus_id_irr2" min={1} max={256} value={environmentitem.modbus_id_irr2} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            modbus_id_irr2: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="modbus_id_amb_rh">Modbus ID Ambient Temp, RH</label>
                                    <input type="number" className="form-control" ref={modbus_id_amb_rhRef} name="modbus_id_amb_rh" min={1} max={256} value={environmentitem.modbus_id_amb_rh} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            modbus_id_amb_rh: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="modbus_id_temp_panel">Modbus ID Panel Temp</label>
                                    <input type="number" className="form-control" ref={modbus_id_temp_panelRef} name="modbus_id_temp_panel" min={1} max={256} value={environmentitem.modbus_id_temp_panel} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            modbus_id_temp_panel: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="modbus_id_temp_raceway">Modbus ID Tray temp</label>
                                    <input type="number" className="form-control" ref={modbus_id_temp_racewayRef} name="modbus_id_temp_raceway" min={1} max={256} value={environmentitem.modbus_id_temp_raceway} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            modbus_id_temp_raceway: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-3">
                                <div className="form-group mb-3">
                                    <label htmlFor="modbus_id_temp_winspeed">Modbus ID Wind Sensor</label>
                                    <input type="number" className="form-control" ref={modbus_id_temp_winspeedRef} name="modbus_id_temp_winspeed" min={1} max={256} value={environmentitem.modbus_id_temp_winspeed} onChange={(e) => {
                                        setEnvironmentitem({
                                            ...environmentitem,
                                            modbus_id_temp_winspeed: e.target.value
                                        })
                                    }} required />
                                </div>
                            </div>
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-3">
                                <div className="form-group">
                                    <label htmlFor="edittime">Edit Time</label>
                                    <input type="text" className="form-control" name="edittime" value={environmentitem.edittime} readOnly />
                                </div>
                            </div>
                        </div>
                    </form>
                    <div className="row">
                        <div className="col-md-3 mb-1 mt-3">
                            <button className="btn btn-warning btn-sm" type="button" onClick={() => { api_save_data() }}><i className="fe-save"></i> Save</button>
                        </div>
                    </div>
                    <hr className="new-section-xs" />
                </div>
            </div>
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}

export default SubAdminEnvironment